import './DashboardToolTip.pcss';
import React from 'react';
import linkImageSrc from 'assets/exclamationYellow.png';
import { ToolTipInfo } from '../../constants/toolTipInfo';
import Button from '../../../common/buttons/DeprecatedButton/DeprecatedButton';
import { PrimaryToolTip } from '../../../common/components/PrimaryToolTip/PrimaryToolTip';

type Props = {
  toolTipInfo: ToolTipInfo;
  useQuestionIcon?: boolean;
};

const DashboardTipInfo = (props: Props) => {
  const { toolTipInfo, useQuestionIcon } = props;

  return (
    <PrimaryToolTip
      anchorElement={
        <div className="dashboard-tip-info__icon">
          {useQuestionIcon ? (
            <img
              src={linkImageSrc}
              alt="link"
              className="dashboard-tip-info__link-icon"
            />
          ) : (
            <i className="fa fa-info-circle" aria-hidden="true" />
          )}
        </div>
      }
    >
      {(closeToolTip?: () => void) => (
        <>
          <div className="dashboard-tool-tip__info">{toolTipInfo.info}</div>

          <div className="dashboard-tool-tip__link-block">
            {toolTipInfo.link && (
              <div className="dashboard-tool-tip__link-text">
                <a
                  className="dashboard-tool-tip__link"
                  href={toolTipInfo.link}
                  target="_blank"
                  rel="nofollow noopener"
                >
                  Check out our Help Doc to learn more
                </a>
              </div>
            )}

            <div className="dashboard-tool-tip__action-block">
              <Button
                className="dashboard-tool-tip__button"
                onClick={closeToolTip}
              >
                Ok, got it
              </Button>
            </div>
          </div>
        </>
      )}
    </PrimaryToolTip>
  );
};

export default DashboardTipInfo;
